export default [
  {
    path: 'ebook-list',
    name: 'ebook-list',
    component: () => import('./tag-setting/index.vue'),
    meta: {
    }
  }
];


// WEBPACK FOOTER //
// ./src/views/operate/eBooks/index.route.js